<template>
  <UModal v-model="isOpen" :title="t('menu.share_menu.title')">
    <UButton
      icon="i-heroicons-share"
      class="lg:hidden"
      size="xl"
      color="neutral"
      variant="ghost"
      :aria-label="t('menu.share_menu.button_aria')"
      @click="isOpen = true"
    />

    <template #body>
      <MenuShareButtons />
    </template>
  </UModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const isOpen = ref(false)
</script>
